exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".container-bfdce{position:relative}.suggestionsList-40368{background-color:#fff;border:.1rem solid #656a70;border-radius:0 0 .3rem .3rem;box-sizing:border-box;list-style:none;margin:0;padding:0;position:absolute;width:100%;z-index:9999999}.suggestion-0ddbb{align-items:center;border-top:.1rem solid #868f96;list-style:none;padding:1.2rem}.suggestion-0ddbb:hover{cursor:pointer}.suggestionFirst-86bf5{border-top:0}.suggestionHighlighted-858d0{background-color:#f2f4f5;color:#0272b6}", ""]);

// Exports
exports.locals = {
	"container": "container-bfdce",
	"suggestionsList": "suggestionsList-40368",
	"suggestion": "suggestion-0ddbb",
	"suggestionFirst": "suggestionFirst-86bf5",
	"suggestionHighlighted": "suggestionHighlighted-858d0"
};